export class buttonStyle {

  static OL_CLOSE = 'm__head__anch';

  static PRIM = 'btn--prim';

  static WHITE = 'btn--white';

  static SECN = 'btn--secn';

  static LARY = 'btn--lgry';

  static OUTL = 'btn--outl';

  static OUTL_LITE = 'btn--outl--lite';

  static TERT = 'btn--tert';

  static TAG = 'btn--tag';

  static LITE = 'btn--lite';

  static TEXT = 'btn--text';

  static WARN = 'btn--warn';

  static SIZABLE = 'btn--disabled';
}

export class buttonSize {
  static FULL = 'btn-full';

  static XLG = 'btn--xlg';

  static LG = 'btn--lg';

  static MD = 'btn--md';

  static SM = 'btn--sm';
}

export class buttonColor {
  static PRIM = 'color--prim';

  static WHITE = "btn--white";
}

export class icons {
  static MAIL = 'i-mail';

  static MSG = 'i-msg';

  static ARROW_LEFT = 'i-arw-l';

  static ARROW_RIGHT = 'i-arw-r';

  static ARROW_BOTTOM = 'i-arw-b';

  static ARROW_TOP = 'i-arw-t';

  static HELP = 'i-help';

  static CHECK = 'i-check';

  static CLOSE_ALT = 'i-close-alt';

  static DELAY = 'i-delay';

  static SEARCH = 'i-search';

  static TRUCK = 'i-truck';

  static DOLLAR_FILL = 'i-dollar-fill';

  static BUILDING = 'i-building';

  static BUILDINGS = 'i-buildings';

  static CLOSE = 'i-close';

  static CODE = 'i-code';

  static COG = 'i-cog';

  static DOLLAR = 'i-dollar';

  static LOGO = 'i-logo';

  static PAYS = 'i-pays';

  static TRI_BOTTOM_FILL = 'i-tri-b-fill';

  static TRI_BOTTOM = 'i-tri-b';

  static TRI_LEFT_FILL = 'i-tri-l-fill';

  static TRI_LEFT = 'i-tri-l';

  static TRI_RIGHT_FILL = 'i-tri-r-fill';

  static TRI_RIGHT = 'i-tri-r';

  static TRI_TOP_FILL = 'i-tri-t-fill';

  static TRI_TOP = 'i-tri-t';

  static USER_FILL = 'i-users-fill';

  static MENU = 'i-menu';

}
